import React from 'react';
import Modal from 'react-modal';

import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { setShowCreatePunchCardModal } from '../../punchCardSlice';
import { CreatePunchCardForm } from '../../components/CreatePunchCardForm/CreatePunchCardForm';

import { ReactComponent as Close } from '../../../../assets/images/close.svg';
import './CreatePunchCardModal.scss';

const modalStyles = {
  overlay: {
    background: "#131313B3"
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: "#FFFFFF",
    padding: 0
  },
};

export function CreatePunchCardModal() {
  const dispatch = useAppDispatch();

  const showCreatePunchCardModal = useAppSelector(state => state.punchCards.showCreatePunchCardModal);

  const isOpen = !!showCreatePunchCardModal;

  const onClose = () => {
    dispatch(setShowCreatePunchCardModal(undefined));
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={modalStyles}
      ariaHideApp={false}
    >
      <div className='create-punch-card-modal-component'>
        <div onClick={onClose} className='close-button'>
          <Close />
        </div>

        <div className='title'>Add Punch Card</div>

        {showCreatePunchCardModal && (
          <CreatePunchCardForm driverId={showCreatePunchCardModal.driverId} />
        )}
      </div>
    </Modal>
  );
}
